import AppLayout from "@amzn/meridian/app-layout";
import { useEffect } from "react";
import ErrorBoundary from "src/components/shared/errorBoundary/errorBoundary";
import Header from "src/components/shared/header/header";
import ChatSideMenu from "src/components/shared/sideMenu/sideMenu";
import SiteToaster from "src/components/shared/siteToaster/siteToaster";
import { useAppDispatch, useAppSelector } from "src/store/store";
import { getUser } from "src/store/userSlice";
import { initAwsRum } from "src/utils/awsRUM";
import { v4 as uuidv4 } from "uuid";
import "./App.scss";
import {
  setAllFavoriteMessages,
  setConversationId,
  setIsFavoriteMessagesLoaded,
  setIsRecentChatsLoaded,
  setRecentChats,
} from "src/components/pages/home/store/chatSlice";
import ChatService from "src/components/pages/home/service/chatService";
import Routes from "src/components/routes/routes";
import ProfileSideSheet from "src/components/shared/profileSideSheet/profileSideSheet";

const App = () => {
  const dispatch = useAppDispatch();
  const { firstName, alias, isAuthorized, token } = useAppSelector(
    (state) => state.user,
  );

  useEffect(() => {
    dispatch(setConversationId(uuidv4()));

    if (!token) {
      dispatch(getUser());
    }
  }, [dispatch, token]);

  useEffect(() => {
    if (alias) {
      initAwsRum(alias);
    }
  }, [alias]);

  useEffect(() => {
    if (isAuthorized && alias) {
      const fetchChatHistory = async () => {
        dispatch(setIsRecentChatsLoaded(false));
        try {
          const response = await ChatService.getRecentChats();
          const favoriteMessages = await ChatService.getAllFavorites();

          dispatch(setAllFavoriteMessages(favoriteMessages));
          dispatch(setRecentChats(response.data.recent_messages));
          dispatch(setIsRecentChatsLoaded(true));
          dispatch(setIsFavoriteMessagesLoaded(true));
        } catch (err) {
          console.error("Failed to fetch chat history", err);
        }
      };

      fetchChatHistory();
    }
  }, [isAuthorized, alias]);

  return (
    <ErrorBoundary>
      <AppLayout headerComponent={Header} sidebarComponent={ChatSideMenu}>
        <SiteToaster />
        <Header />
        <ChatSideMenu />
        <Routes />
        <ProfileSideSheet />
      </AppLayout>
    </ErrorBoundary>
  );
};

export default App;
